import React from 'react'

function PageNotFound() {
  return (
    <div>You Are On Wrong Page_404</div>
  )
}

export default PageNotFound